    <p class="highcharts-title ehs-title">
        Personal Safety
    </p>
    <p class="ehs-sub-title">
        {{ehs_Injury_Text}}
    </p>

    <p style="width: 100%; text-align: center; margin: 0px; border-bottom-color:white;">
        <!--https://canvas-gauges.com/documentation/user-guide/configuration-->
        <linear-gauge   width="106"
                        height="250"
                        start-angle="90"
                        ticks-angle="180"
                        stroke-ticks="true"
                        ticks-width="15"
                        ticks-width-minor="7.5"
                        color-major-ticks="#333333"
                        color-minor-ticks="#b3b3b3"                        
                        [attr.major-ticks]="majorTicks"
                        minor-ticks=1
                        value-box="false"
                        [attr.highlights]="ehsActualHarm_highlights"
                        needle="true"
                        needle-circle-size="10"
                        needle-circle-outer="true"
                        needle-circle-inner="false"
                        needle-type="arrow"
                        needle-width="1"
                        color-needle="#222"
                        color-needle-end="0"
                        units="false"
                        borderShadowWidth=0
                        font-numbers-size="30"
                        borders=false
                        stroke-ticks="true"
                        color-plate="#fff"
                        border-shadow-width="0"
                        color-bar-progress="#0088CE"
                        color-bar="#f5f5f5"
                        color-bar-stroke="#000000"
                        bar-stroke="1"
                        bar-width="18"
                        min-value="0"
                        [attr.max-value]="ehs_Injury_Max"
                        [attr.value]="ehs_Injury_CurrentYearValue">
        </linear-gauge>          
    </p>

    <p class="comment" style="text-align: center; width: 100%; font-size:medium;">
        <em><b>{{ehs_CurrentYear-1}}:&nbsp;</b></em>{{ehs_Injury_LastYearValue}}&nbsp;&nbsp;&nbsp;
        <em><b>{{ehs_CurrentYear}}:&nbsp;</b></em>{{ehs_Injury_CurrentYearValue}} YTD
    </p>